import { WalletTokenState } from '../coinLiquidation/walletTokenFetcher';

const CACHE_EXPIRY_TIME = 120 * 60 * 1000; // 2 hours

const getCacheKey = (address: string) => `wallet_tokens_${address}`;

export const getCachedTokens = (address: string): WalletTokenState | null => {
  try {
    const cacheKey = getCacheKey(address);
    const cached = localStorage.getItem(cacheKey);
    if (!cached) return null;

    const { data, timestamp } = JSON.parse(cached);
    const now = Date.now();

    if (now - timestamp > CACHE_EXPIRY_TIME) {
      localStorage.removeItem(cacheKey);
      return null;
    }

    return data;
  } catch (error) {
    return null;
  }
};

export const cacheTokens = (address: string, data: WalletTokenState): void => {
  try {
    const cacheKey = getCacheKey(address);
    const cacheData = {
      data,
      timestamp: Date.now()
    };
    localStorage.setItem(cacheKey, JSON.stringify(cacheData));
  } catch (error) {
    // Error caching tokens
  }
};

